// Brand configuration - detects domain and returns brand-specific settings
const BRANDS = {
  clicdoc: {
    id: 'clicdoc',
    name: 'ClicDoc',
    domain: 'clicdoc.com.br',
    price: 59,
    priceFormatted: 'R$ 59',
    specialty: 'Clínico Geral',
    description: 'Consulta médica online com clínico geral',
    theme: 'light',
    primaryColor: '#16a34a',
    logo: 'https://customer-assets.emergentagent.com/job_app-landing-hub-6/artifacts/qon6v0ui_logo%20header.png',
    canonical: 'https://clicdoc.com.br',
  },
  urologista: {
    id: 'urologista',
    name: 'Urologista Online',
    domain: 'uronline.com.br',
    price: 190,
    priceFormatted: 'R$ 190',
    specialty: 'Urologista',
    doctorName: 'Dr. Rodrigo Seben',
    doctorCRM: 'CRM/RS 30092',
    doctorImage: 'https://static.wixstatic.com/media/5df835_c688ae377a324fffa38ad9802709461e~mv2.jpg/v1/fill/w_525,h_379,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_0032.jpg',
    description: 'Teleconsulta com urologista especialista',
    theme: 'dark',
    primaryColor: '#D4AF37',
    canonical: 'https://uronline.com.br',
    treatments: [
      { title: 'Rins, Bexiga e Próstata', desc: 'Diagnóstico e tratamento de doenças renais, vesicais e prostáticas' },
      { title: 'Saúde Sexual Masculina', desc: 'Impotência, ejaculação precoce e disfunções eréteis' },
      { title: 'Reposição Hormonal', desc: 'Andropausa e disfunção hormonal masculina' },
      { title: 'Infecções Urinárias', desc: 'Cistite, pielonefrite e infecções recorrentes' },
      { title: 'ISTs', desc: 'HPV, uretrite, sífilis e outras infecções sexualmente transmissíveis' },
      { title: 'Testículos e Pênis', desc: 'Varicocele, hidrocele, fimose e outras condições' },
    ],
  },
};

export function getBrand() {
  const hostname = window.location.hostname;
  if (hostname.includes('uronline') || hostname.includes('urologista')) {
    return BRANDS.urologista;
  }
  // Check URL param for preview testing: ?brand=urologista
  const params = new URLSearchParams(window.location.search);
  if (params.get('brand') === 'urologista') {
    return BRANDS.urologista;
  }
  return BRANDS.clicdoc;
}

export function getBrandById(id) {
  return BRANDS[id] || BRANDS.clicdoc;
}

export default BRANDS;
